// The Plaid sandbox users seeded for dev (docs/dev-seed.md). Mock mode's
// stand-in for Plaid Link offers the same logins, so the mock Connections
// screen looks like dev after connecting them.

export interface SeedLogin {
  /** Plaid sandbox username (password pass_good). */
  user: string;
  institution: string;
  accounts: { name: string; mask: string; type: 'depository/checking' | 'credit/credit card' }[];
}

const card = (name: string, mask: string) => ({ name, mask, type: 'credit/credit card' as const });

export const SEED_LOGINS: SeedLogin[] = [
  { user: 'custom_fw_checking', institution: 'First Platypus Bank', accounts: [{ name: 'Operating Checking', mask: '5331', type: 'depository/checking' }] },
  {
    user: 'custom_fw_amex',
    institution: 'First Platypus Bank',
    accounts: [
      card('Amex Skyline Rewards', '4330'), card('Amex Business Copper', '6427'), card('Amex Teal Business', '5884'),
      card('Amex Lodging Plus', '9796'), card('Amex Hotel Points', '8693'),
    ],
  },
  {
    user: 'custom_fw_chase',
    institution: 'First Platypus Bank',
    accounts: [
      card('Chase Resort Visa', '1764'), card('Chase Hotel Club MC', '4258'), card('Chase Lodging Rewards', '7390'),
      card('Chase Summit Visa', '6008'), card('Chase Summit Visa 2', '3095'),
    ],
  },
];
